import React, { useCallback } from 'react';
import { Field, Form } from 'react-final-form';
import { connect } from 'react-redux';

import { notify } from '@/actions/ui';
import Dialog from '@/components/Dialog/Dialog';
import { RadioGroup } from '@/components/FormAdapters';
import { changeCarrier } from '@/consultation/store';
import { capitalize } from '@/utils';

function ChangeCarrierDialog({
  consultation,
  changeCarrier,
  initialValues,
  notify,
  onClose,
  ...other
}: any) {
  const handleSubmit = useCallback(async (values: any) => {
    try {
      const carrier = values?.carrier;
      if (consultation && carrier) {
        await changeCarrier({ consultation, carrier });
        notify('Carrier updated.', 'success');
      }
    } catch (err) {
      notify('An error occurred when changing carrier.', 'error');
      throw err;
    }
    onClose();
  }, []);

  return (
    <Form onSubmit={handleSubmit} initialValues={initialValues} subscription={{ submitting: true }}>
      {({ handleSubmit, submitting }) => {
        return (
          <Dialog
            {...other}
            title="Change Carrier"
            maxWidth="xs"
            onConfirm={handleSubmit}
            onClose={onClose}
            onCancel={onClose}
            disableSubmit={submitting}
            cancelLabel="Cancel"
            confirmLabel="Save"
          >
            <form onSubmit={(e) => handleSubmit(e)}>
              <Field
                component={RadioGroup}
                name="carrier"
                options={['twilio', 'zoom'].map((c) => ({
                  value: c,
                  label: `${capitalize(c)}`,
                }))}
              />
            </form>
          </Dialog>
        );
      }}
    </Form>
  );
}

// @ts-expect-error TS(2630) FIXME: Cannot assign to 'ChangeCarrierDialog' because it ... Remove this comment to see the full error message
ChangeCarrierDialog = connect(undefined, {
  changeCarrier,
  notify,
})(ChangeCarrierDialog);

export default ChangeCarrierDialog;
